<template>
    <ViewBonLivraison/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ViewBonLivraison from "@/components/GesCom/BonLivraison/ViewBonLivraison.vue";

    export default defineComponent({
      name: "ViewBonLivraisonPage",
      components: {
        ViewBonLivraison,
      },
    });
  </script>